import { Toaster } from '@/components/ui/toaster'
import { NhostProvider } from '@nhost/react'
import { NhostApolloProvider } from '@nhost/react-apollo'
import { StoreProvider } from 'easy-peasy'
import React, { useMemo } from 'react'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'
import { nhost } from 'src/nhost'
import i18n from './i18n'
import AppRoute from './routes/AppRoute'
import { store } from './store'

import { InMemoryCache } from '@apollo/client'
import { defaultDataIdFromObject } from '@apollo/client'

import 'non.geist'
import './index.css'

export default function App() {
  const cache = useMemo(
    () =>
      new InMemoryCache({
        dataIdFromObject(responseObject) {
          // console.debug('responseObject:', responseObject)
          switch (responseObject.__typename) {
            case 'estate_seller':
              return `estate_seller:${responseObject.estateId}:${responseObject.sellerId}`
            default:
              return defaultDataIdFromObject(responseObject)
          }
        },
      }),
    []
  )

  return (
    <I18nextProvider i18n={i18n}>
      <NhostProvider nhost={nhost}>
        <NhostApolloProvider
          nhost={nhost}
          headers={{ 'X-Hasura-Role': 'user' }}
          cache={cache}
        >
          <StoreProvider store={store}>
            <Router>
              <AppRoute />
            </Router>
            <Toaster />
          </StoreProvider>
        </NhostApolloProvider>
      </NhostProvider>
    </I18nextProvider>
  )
}
